import { Component, forwardRef, Input } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true,
    },
  ],
})
export class ToggleComponent implements ControlValueAccessor {
  @Input() formGroup: FormGroup;
  @Input() formControlName = '';
  @Input() label = '';
  @Input() negative = { label: '', value: undefined };
  @Input() positive = { label: '', value: undefined };

  value: string;

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  toggle() {
    let value = this.formGroup.value[this.formControlName];
    let newValue;
    if (value == this.negative.value) {
      newValue = this.positive.value;
    } else {
      newValue = this.negative.value;
    }
    this.formGroup.controls[this.formControlName].setValue(newValue);
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value); // Notify the form about the change
    this.onTouched(); // Mark as touched
  }
}
